import React from "react";
import PageLayout from "../components/PageLayout";

export default function Policy() {
    return (
        <PageLayout
            title="Privacy Policy for"
            titleHighlight="Pharmacy Wiki"
            subtitle="Last updated: Feb 25, 2025"
            pageTitle="Privacy Policy"
            showSearch={false}
            showGradient={true}
        >
            <div className="flex flex-col gap-3 mt-8 text-secondary/80 text-14">
                <div className="text-secondary">
                    Pharmacy.Wiki is a free informational site. We do not require or request that you log in, sign up, or provide your email address or any other personal data to access our content.
                </div>
                <div>
                    This Privacy Policy explains how we collect, use, and safeguard any information that may be incidentally collected when you visit our website. Pharmacy.Wiki is a fictional site for a book project that provides information about generic medicines, including pharmacy brand names (e.g., Cialis), their chemical names (e.g., tadalafil), and listings of manufacturers producing generic equivalents.
                </div>
                <div>
                    By accessing or using our Site, you agree to the terms of this Privacy Policy. If you do not agree with our practices, please do not use the Site.
                </div>
                <hr className="my-4 border-t border-gray-300" />
                <div className="font-semibold text-16 text-secondary">
                    1. Information We Collect
                </div>
                <div>
                    Since we do not require user registration or account creation, we do not collect any Personal Information directly from our visitors. However, we may still collect certain information automatically through your use of the Site.
                </div>
                <div className="font-semibold">
                    Non-Personal Information
                </div>
                <div>
                    We may automatically collect Non-Personal Information that does not directly identify you. This includes:
                </div>
                <div>
                    <ul className="ml-5 list-disc">
                        <li>
                            Browser and Device Information: Such as browser type, version, and operating system.
                        </li>
                        <li>
                            IP Address: Used for statistical and analytical purposes.
                        </li>
                        <li>
                            Usage Data: Including referring/exit pages, date/time stamps, clickstream data, and aggregated statistical data.
                        </li>
                    </ul>
                </div>
                <div>
                    This information is used solely to enhance and optimize the performance of our Site and to better understand our audience.
                </div>
                <div className="font-semibold text-16 text-secondary">
                    2. How We Use Your Information
                </div>
                <div>
                    Since no Personal Information is collected through user registrations or logins, our use of the automatically collected Non-Personal Information is limited to the following purposes:
                </div>
                <div>
                    <ul className="ml-5 list-disc">
                        <li>
                            Site Functionality: To provide, operate, and maintain the Site.
                        </li>
                        <li>
                            Performance Analysis: To analyze how the Site is used, monitor trends, and improve our content and functionality.
                        </li>
                        <li>
                            Security: To help protect against unauthorized access or security breaches.
                        </li>
                        <li>
                            Legal Compliance: To comply with applicable laws and respond to legal requests or proceedings.
                        </li>
                    </ul>
                </div>
                <div className="font-semibold text-16 text-secondary">
                    3. Cookies and Tracking Technologies
                </div>
                <div>
                    Our Site may use cookies, web beacons, and similar tracking technologies to enhance your user experience and collect Non-Personal Information. Cookies are small data files stored on your device that help us analyze usage patterns and improve the Site.
                </div>
                <div className="font-semibold">
                    You can set your browser to refuse cookies, but note that some parts of the Site may not function properly if you do so.
                </div>
                <div className="font-semibold text-16 text-secondary">
                    4. Third-Party Websites
                </div>
                <div>
                    Our Site may include links to third-party websites for additional information or resources. This Privacy Policy does not apply to those sites. We encourage you to review the privacy policies of any third-party sites you visit.
                </div>
                <div className="font-semibold text-16 text-secondary">
                    5. Data Security
                </div>
                <div>
                    We implement reasonable administrative, technical, and physical safeguards to protect the information collected through the Site against unauthorized access, disclosure, alteration, and destruction. However, please note that no security system is completely infallible, and we cannot guarantee the absolute security of your data.
                </div>
                <div className="font-semibold text-16 text-secondary">
                    6. Data Retention
                </div>
                <div>
                    Since we do not collect Personal Information through registrations or logins, we retain only Non-Personal Information for as long as necessary to fulfill the purposes outlined above and to comply with our legal obligations. Non-Personal Information may be retained indefinitely in aggregated form.
                </div>
                <div className="font-semibold text-16 text-secondary">
                    7. Your Rights and Choices
                </div>
                <div>
                    Because we do not collect Personal Information from you, your ability to exercise rights such as access, correction, or deletion is limited. However, if you have any questions or concerns about the Non-Personal Information we collect or its use, please contact us using the details provided below.
                </div>
                <div className="font-semibold text-16 text-secondary">
                    8. Changes to This Privacy Policy
                </div>
                <div>
                    We reserve the right to modify this Privacy Policy at any time. If we make material changes, we will update the "Last Updated" date at the top of this Privacy Policy. Your continued use of the Site after such changes indicates your acceptance of the updated Privacy Policy.
                </div>
                <div className="font-semibold text-16 text-secondary">
                    9. Contact Us
                </div>
                <div>
                    If you have any questions, concerns, or comments about this Privacy Policy or our data practices, please contact us at: support@phamarcy.wiki
                </div>
            </div>
        </PageLayout>
    );
}